module.exports = __webpack_public_path__ + "gs.svg?e0781d5f0aa876f21fb1689a754e6815";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gs.svg
// module id = 1072
// module chunks = 27